<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.TITLE' | translate }}</h4>
  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableAccentColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.CARD_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tablePrimaryColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.PRIMARY_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableBackgroundColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <div class="opacity-slider-container">
    <label class="opacity-label">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.OPACITY' | translate }}</label>
    <div class="slider-wrapper">
      <mat-slider min="0" max="1" step="0.01" discrete>
        <input matSliderThumb [formControl]="opacityControl" />
      </mat-slider>
      <span class="opacity-value">{{ opacityControl.value }}</span>
    </div>
  </div>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.SIZE' | translate }}</mat-label>
    <input matInput type="number" [formControl]="fontSizeControl" min="1" max="20" />
    @if (fontSizeControl.hasError('max')) {
      <mat-error>
        {{ 'PRESENTER.HONOUR_ROLL_TOOLS.FONT_SIZE_MAX_ERROR' | translate }}
      </mat-error>
    }
  </mat-form-field>

  <mat-slide-toggle [formControl]="showItemAliasControl">
    {{ 'PRESENTER.HONOUR_ROLL_TOOLS.SHOW_ITEM_CODE' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="showItemNameControl">
    {{ 'PRESENTER.HONOUR_ROLL_TOOLS.SHOW_ITEM_NAME' | translate }}
  </mat-slide-toggle>

  <h5 class="tools-section-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.ADVANCED_OPTIONS' | translate }}</h5>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.LATEST_ACTIVITY_QUANTITY' | translate }}</mat-label>
    <input matInput type="number" [formControl]="latestActivitiesControl" min="1" max="100" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.PARTICIPANTS_TRANSITION' | translate }}</mat-label>
    <mat-select [formControl]="transitionControl">
      @for (option of participantsTransitionOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Deprecated -->
  <!-- <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.NUMBER_ACTIVITIES_VISIBLE' | translate }}</mat-label>
    <input matInput type="number" [formControl]="numberActivitiesVisibleControl" min="1" max="20" />
  </mat-form-field> -->

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.PAGE_SHOW_DURATION' | translate }}</mat-label>
    <input matInput type="number" [formControl]="slideIntervalControl" min="1" max="60" />
    <span matTextSuffix>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.SECONDS' | translate }}</span>
    @if (slideIntervalControl.hasError('max')) {
      <mat-error>
        {{ 'PRESENTER.HONOUR_ROLL_TOOLS.PAGE_SHOW_DURATION_MAX_ERROR' | translate }}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.BORDER_WIDTH' | translate }}</mat-label>
    <input matInput type="number" [formControl]="borderWidthControl" min="0" max="100" />
    <span matTextSuffix>{{ 'PX' | translate }}</span>
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="borderColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.BORDER_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.BORDER_STYLE' | translate }}</mat-label>
    <mat-select [formControl]="borderStyleControl">
      @for (option of borderStyleOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-stroked-button type="button" class="preset-button" (click)="openFilterItemsDialog()">
    <span class="button-inner">
      <gb-icon icon="filter" height="18px"></gb-icon>
      <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.BUTTON' | translate }}</span>
    </span>
  </button>
</div>
